import announcementService from "@/services/announcement/announcementService";
import type { Commit } from "vuex";

type Announcement = {
  id: 0,
  tags: string,
  author: string,
  url: string,
  created_at: string,
  updated_at: string,
  title: string,
  content: string,
  is_featured: boolean,
  thumbnail: string,
  slug: string
};

type AnnouncementPayload = {
  announcementList: [];
  announcementCount: number;
  announcementNext: string;
  announcementPrevious: string;
}

const state = {
  announcementList: null,
  announcementCount: null,
  announcementNext: null,
  announcementPrevious: null,
  announcementItem: null,
  MESSAGE: null
}
const getters = {
  getAnnouncementList: (state: AnnouncementPayload): [] => { return state.announcementList },
  getAnnouncementCount: (state: AnnouncementPayload): number => { return state.announcementCount },
  getAnnouncementNext: (state: AnnouncementPayload): string => { return state.announcementNext },
  getAnnouncementPrevious: (state: AnnouncementPayload): string => { return state.announcementPrevious },
  getAnnouncementItem: (state: { announcementItem: Announcement }): Announcement => { return state.announcementItem },
  getMessage: (state: { MESSAGE: string }): string => { return state.MESSAGE }
}
const actions = {
  fetchAnnouncementList({ commit }: { commit: Commit }): void {
    announcementService.fetchAnnouncementList()
      .then(payload => {
        commit("setAnnouncementList", payload);
      });
  },
  fetAnnouncementItem({ commit }: { commit: Commit }, slug: string): void {
    announcementService.fetchAnnouncement(slug)
      .then(payload => { commit("setAnnouncementItem", payload); });
  },
  createAnnouncement({ commit }: { commit: Commit }, announcement: {}): void {
    announcementService.createAnnouncement(announcement)
      .then(payload => {
        commit("createAnnouncementItem", payload);
      });
  },
  editAnnouncement({ commit }: { commit: Commit }, slug: string, announcement: {}): void {
    announcementService.editAnnouncement(slug, announcement)
      .then(payload => {
        commit("setAnnouncementItem", payload);
      });
  },
  deleteAnnouncement({ commit }: { commit: Commit }, id: number): void {
    announcementService.deleteAnnouncementItem(id)
      .then(() => {
        commit("setMessage", "Deleted Successfully.");
      })
      .catch(error => {
        commit("setMessage", error.message);
      });
  }
}
const mutations = {
  setAnnouncementList(state: AnnouncementPayload, payload: { count: number, next: string, previous: string, results: [] }): void {
    state.announcementList = payload.results;
    state.announcementCount = payload.count;
    state.announcementNext = payload.next;
    state.announcementPrevious = payload.previous;
  },
  setAnnouncementItem(state: { announcementItem: Announcement }, payload: Announcement): void {
    state.announcementItem = payload;
  },
  createAnnouncementItem(state: { announcementItem: {} }, announcementItem: {}): void {
    state.announcementItem = announcementItem;
  },
  setMessage(state: { MESSAGE: string }, message: string): void {
    state.MESSAGE = message;
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
